import * as mutation from "./mutation-types";
import { tableHelper } from "@/helpers/table.helper";
import {
  getBlankRecord,
  getBlankFeesRecord,
  getBlankInvoiceConfigurationRecord,
  getBlankInvoicingTimingConfigurationRecord,
  getBlankLevyCalculationTimingConfigurationRecord,
  getBlankEmailConfigurationRecord,
  getBlankInformationSessionRecord,
  getBlankDataSourceConfigurationRecord,
  getBlankNonComplianceHistoryConfiguration,
  getBlankPublicLevyEstimatorConfiguration
} from "./helpers";

export const state = getInitialState();

export function getInitialState() {
  return {
    listing: {
      criteria: {},
      data: [],
      paging: tableHelper.getDefaultPaging(),
      loading: false,
      loaded: false
    },
    view: {
      data: getBlankRecord(),
      breadcrumbs: [{ text: "..." }],
      loading: false,
      loaded: false
    },
    statusHistory: {
      levyCollectionId: null,
      loaded: false,
      loading: false,
      data: []
    },
    edit: {
      data: getBlankRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "edit"
      }
    },
    viewFees: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankFeesRecord()
    },
    editFees: {
      data: getBlankFeesRecord(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editFees"
      }
    },
    viewNonComplianceHistoryConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankNonComplianceHistoryConfiguration()
    },
    editNonComplianceHistoryConfiguration: {
      data: getBlankNonComplianceHistoryConfiguration(),
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editNonComplianceHistoryConfiguration"
      }
    },
    editPublicLevyEstimatorConfiguration: {
      data: getBlankPublicLevyEstimatorConfiguration(),
      levyCollectionId: null,
      loading: false,
      saving: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editPublicLevyEstimatorConfiguration"
      }
    },
    create: {
      type: null,
      saving: false,
      data: getBlankRecord()
    },
    totalLevyAmounts: {
      chartData: null,
      loading: false,
      loaded: false
    },
    componentLevyAmounts: {
      chartData: null,
      loading: false,
      loaded: false
    },
    pdfTemplate: {
      loading: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "pdfTemplate"
      }
    },
    providerTasks: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: []
    },
    tasks: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: []
    },
    task: {
      processing: false,
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "task"
      }
    },
    widgets: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: null
    },
    setup: {
      saving: false
    },
    viewInvoiceConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankInvoiceConfigurationRecord()
    },
    editInvoiceConfiguration: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankInvoiceConfigurationRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editInvoiceConfiguration"
      }
    },
    viewInvoicingTimingConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankInvoicingTimingConfigurationRecord()
    },
    editInvoicingTimingConfiguration: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankInvoicingTimingConfigurationRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editInvoicingTimingConfiguration"
      }
    },
    viewLevyCalculationTimingConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankLevyCalculationTimingConfigurationRecord()
    },
    editLevyCalculationTimingConfiguration: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankLevyCalculationTimingConfigurationRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editLevyCalculationTimingConfiguration"
      }
    },
    viewEmailConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankEmailConfigurationRecord()
    },
    editEmailConfiguration: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankEmailConfigurationRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editEmailConfiguration"
      }
    },
    viewDataSourceConfiguration: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: getBlankDataSourceConfigurationRecord()
    },
    editDataSourceConfiguration: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankDataSourceConfigurationRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editDataSourceConfiguration"
      }
    },
    viewInformationSessions: {
      loading: false,
      loaded: false,
      levyCollectionId: null,
      data: []
    },
    editInformationSession: {
      loading: false,
      saving: false,
      levyCollectionId: null,
      data: getBlankInformationSessionRecord(),
      error: {
        show: false,
        details: {},
        hideMutation: mutation.STATE_HIDE_ERROR,
        hideArgument: "editInformationSession"
      }
    }
  };
}

export function getUnloadedState() {
  return {
    listing: { loaded: false },
    view: { loaded: false },
    totalLevyAmounts: { loaded: false },
    componentLevyAmounts: { loaded: false },
    providerTasks: { loaded: false },
    statusHistory: { loaded: false },
    tasks: { loaded: false },
    viewDataSourceConfiguration: { loaded: false },
    viewEmailConfiguration: { loaded: false },
    viewInvoiceConfiguration: { loaded: false },
    viewInvoicingTimingConfiguration: { loaded: false },
    viewNonComplianceHistoryConfiguration: { loaded: false },
    viewLevyCalculationTimingConfiguration: { loaded: false },
    viewInformationSessions: { loaded: false },
    viewFees: { loaded: false }
  };
}
